import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import { Button } from '~/components/Button';

interface ForcedSignupDialogProps {
  open?: boolean;
  onClose?: () => void;
  reason: string;
}

export default function ForcedSignupDialog({
  open = false,
  onClose,
  reason,
}: ForcedSignupDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{reason}</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 2, mb: 4 }}>
          To continue searching, you&apos;ll need to register for a free
          account.
        </Typography>

        <Stack spacing={2} sx={{ px: 3, textAlign: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            href="/signup?reason=search.count">
            Sign Up For Free
          </Button>
          <Button variant="outlined" size="large" fullWidth href="/login">
            Log In
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
